/**
 * Top Risks — interrogated (rule 8). Each risk renders its name + description and
 * three sub-fields: what is known, what is assumed, incentive to underestimate.
 * Gracefully handles legacy reports where top_risks were plain strings.
 */
import { Block } from "./Block";

const SUBS = [
  ["what_is_known", "What is known"],
  ["what_is_assumed", "What is assumed"],
  ["incentive_to_underestimate", "Incentive to underestimate"],
];

export default function TopRisksBlock({ items, title = "Top Risks — Interrogated" }) {
  if (!items || !items.length) return null;
  return (
    <Block title={title}>
      <div className="space-y-5" data-testid="top-risks-block">
        {items.map((r, idx) => {
          if (typeof r === "string") {
            return <p key={idx} className="text-slate-700 leading-relaxed">{r}</p>;
          }
          return (
            <div key={idx} className="border-l-2 border-teal-500 pl-4" data-testid={`top-risk-${idx}`}>
              <p className="font-semibold text-slate-900">{r.risk}</p>
              {r.description && <p className="mt-1 text-sm text-slate-700 leading-relaxed">{r.description}</p>}
              <dl className="mt-3 space-y-2">
                {SUBS.filter(([k]) => r[k]).map(([k, label]) => (
                  <div key={k} className="grid grid-cols-1 sm:grid-cols-[170px_1fr] gap-1 sm:gap-3">
                    <dt className="text-[11px] uppercase tracking-[0.1em] text-slate-500 pt-0.5">{label}</dt>
                    <dd className="text-sm text-slate-700 leading-relaxed">{r[k]}</dd>
                  </div>
                ))}
              </dl>
            </div>
          );
        })}
      </div>
    </Block>
  );
}
